import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll';
import './Home.css'
import Banner1 from '../assets/banner1.png';
import { Link } from 'react-router-dom';
import img1 from '../assets/img1.jpeg'
import img2 from '../assets/img2.jpg'
import img3 from '../assets/img3.jpg'
import img4 from '../assets/img4.jpg'
import img5 from '../assets/img5.jpg'
import img6 from '../assets/img6.jpg'
import img7 from '../assets/img7.jpg'
import img8 from '../assets/img8.jpg'
import img9 from '../assets/img9.jpg'
import img10 from '../assets/img10.jpg'
import img11 from '../assets/img11.jpg'
import img12 from '../assets/img12.jpg'
import img13 from '../assets/img13.jpg'
import img14 from '../assets/img14.jpg'
import img15 from '../assets/img15.jpg'
import img16 from '../assets/img16.jpg'

import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';


const Home = ({ setResponse, setLoading }) => {

  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [notice, setNotice] = useState([]);
  const [banner, setBanner] = useState([]);


  // const blogss = [
  //   {
  //     id: 1,
  //     title: "Blog 1",
  //     post: '2 Jan 2025',
  //     desc: "Social studies is the study of individuals, communities, systems, and their interactions across time and place that prepares students for local, national, and global civic life.",
  //     img: img16
  //   },
  //   {
  //     id: 2,
  //     title: "Blog 2",
  //     post: '2 Jan 2025',
  //     desc: "Social studies is the study of individuals, communities, systems, and their interactions across time and place that prepares students for local, national, and global civic life.",
  //     img: img15
  //   },
  //   {
  //     id: 3,
  //     title: "Blog 3",
  //     post: '2 Jan 2025',
  //     desc: "This is another example blog for scrolling UI.",
  //     img: img13
  //   },
  //   {
  //     id: 4,
  //     title: "Blog 4",
  //     post: '2 Jan 2025',
  //     desc: "Keep adding as many blogs as you want here.",
  //     img: img13
  //   }
  //   ,
  //   {
  //     id: 2,
  //     title: "Blog 2",
  //     post: '2 Jan 2025',
  //     desc: "Social studies is the study of individuals, communities, systems, and their interactions across time and place that prepares students for local, national, and global civic life.",
  //     img: img15
  //   },
  //   {
  //     id: 3,
  //     title: "Blog 3",
  //     post: '2 Jan 2025',
  //     desc: "This is another example blog for scrolling UI.",
  //     img: img13
  //   },
  //   {
  //     id: 4,
  //     title: "Blog 4",
  //     post: '2 Jan 2025',
  //     desc: "Keep adding as many blogs as you want here.",
  //     img: img13
  //   }
  // ];

  const instaImages = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
  ];

  const fetchNotice = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-notice');

      if (response.ok) {
        const data = await response.json();
        data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setNotice(data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error('Failed to fetch coupon');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };


    const fetchBanner = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-banner');

      if (response.ok) {
        const data = await response.json();
        setBanner(data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error('Failed to fetch banner');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };


  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-blog');

      if (response.ok) {
        const data = await response.json();
        data.sort((a, b) => new Date(b.posted_on) - new Date(a.posted_on));
        setBlogs(data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error('Failed to fetch coupon');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchBlogs();
    fetchNotice();
    fetchBanner();
  }, []);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  return (
    <>

       {/* slider section */}
       <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
   <div class="carousel-inner">
         {banner.length > 0 ? (
            banner.map((offer, index) => {
                const bannerUrl = `https://api.kcian.in/uploads/${offer.image}`;
                return (
                  <>
                    <div
                        key={index}
                        className={`carousel-item ${index === 0 ? 'active' : ''}`}
                    >
                            <img src={bannerUrl} class="slider-img w-100" alt="banner" />

      <div className='carousel-content'>
        <div className='carousel-inner2 animate__animated animate__fadeInUp'>
        <hr className='slider-hr' />
                            <p className='carousel-heading'>{offer.tagline}</p>
                            <p>{offer.description}</p>
                        </div>
                        </div>
                    </div>
                    </>
                );
            })
        ) : (
    <div className="slider-section" style={{ backgroundImage: `url(${Banner1})` }}>
        <div className="slider-overlay">
          <div className="slider-content text-start my-3 p-4 col-lg-5 col-md-6 col-sm-7 col-10">

            <h1 className='fm-dscript'>
              Enquire Today for <span className="highlight fm-dscript">Admissions</span>
            </h1>
            <p>Start your child’s educational journey with us! Enquire today to learn more about our admissions process, programs, and how we nurture academic excellence and holistic development.</p>
            <button className="discover-now-btn"><a href='/'>Discover The School</a></button>
          </div>
        </div>
      </div>
        )}

  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

      {/* slider section ends */}


      {/* silder section */}
      {/* <div className="slider-section" style={{ backgroundImage: `url(${Banner1})` }}>
        <div className="slider-overlay">
          <div className="slider-content">
            <h1 className='fm-dscript'>
              Enquire Today for <span className="highlight fm-dscript">Admissions</span>
            </h1>
            <p>Start your child’s educational journey with us! Enquire today to learn more about our admissions process, programs, and how we nurture academic excellence and holistic development.</p>
            <Link to='/about'><button className="discover-now-btn">Discover The School</button></Link>
          </div>
        </div>
      </div> */}
      {/*end silder section */}




      {/* notice section */}
      <section className='py-5 px-3'>
        <div className='container bg-light py-5 px-4 rounded-4'>

          <div className='d-flex justify-content-between'>
            <p className='about-heading' style={{color:'#FF9149'}}>Latest Notice</p>
            <p className='align-content-center fw-bold fm-mont cursor-pointer' onClick={() => navigate('/academics')}>View All <i class="fa-solid fa-clipboard-list"></i></p>
          </div>
          <div className='notice-area'>

            {notice && notice.length > 0 ? (
              notice.slice(0, 3).map((notices, index) => (
                <div key={index} className='my-3 border-bottom'>
                  <p className='fw-bold fm-mont my-1'>{notices.tagline}</p>
                  <p className='para-text text-muted fw-semibold'>Date Posted On: {formatDateTime(notices.date)}</p>
                  <p className='text-muted fm-mont para-text'>Details: {notices.description}</p>
                </div>
              ))
            ) : (
              <p className='my-3 text-muted'>There are currently no notices to display. Please check back later for updates.</p>
            )}

          </div>

        </div>
      </section>
      {/* notice section ends */}


      {/* about section */}
      <ScrollAnimation animateIn='fadeInUp'>
        <div className='container py-5 px-md-5 px-4 bg-light rounded-4'>
          <p className='about-heading' style={{color:'#FF9149'}}>What sets us part</p>
          <p><span className='fs-1 fw-bold'>T</span>he school was established in the year 1984 by the sincere and dynamic efforts of Smt. V. Sugnana Kumari Deo, President, K. C. Trust Managing Committee. K. C. Trust is a non-profit, educational body widely recognized for its commitment to excellence in education. Education leadership and scholarly achievement is its mission. Strong in tradition it has evolved as a matrix among the educational institutions in the district of Ganjam, Odisha.</p>
        </div>
      </ScrollAnimation>
      {/* about section ends */}


      {/* 4-cards */}
      <div className='main-section'>
        <div className='first-section'>
          <div className='image-section'>
            <img src={img1} alt='' />
          </div>
          <div className='description-section'>
            <h3>Student Life</h3>
            <p>"Student life at KC Public School blends learning, sports, arts, and activities, creating a fun, engaging, and memorable experience."</p>
            <Link to='/achievements'><button>Student information</button></Link>
          </div>
        </div>
        <div className='second-section'>
          <div className='description-section'>
            <h3>Open Enrollment</h3>
            <p>"Open enrollment at KC Public School is now live — secure your child’s seat for a year of learning, growth, and success." </p>
            <Link to='/contact'><button>Apply Today</button></Link>
          </div>
          <div className='image-section'>
            <img src={img7} alt='' />
          </div>
        </div>
      </div>
      {/*end 4-cards */}

      {/* safely-measures */}
      <div className='safely-measures'>
        <h2>SAFETY MEASURES IN PLACE</h2>
        <p>"KC Public School prioritizes student safety with secure campus entry, CCTV monitoring, trained security personnel, health checks,<br></br> and regular emergency drills. Our proactive measures create a safe, supportive environment where <br></br>students can focus on learning, growth, and enjoying their school experience."</p>
        {/* <button class="btn btn-primary">Safely Measures</button> */}
      </div>
      {/*end safely-measures */}



      {/* gallery section */}

      <section className="life-culture">
        <div className="life-culture-container">
          <h2 className="life-heading">LIFE & CULTURE</h2>
          <p className="life-sub">
            Follow <span>#kcshool</span> on Instagram
          </p>

          <ScrollAnimation animateIn='fadeInUp' className="life-grid">
            {instaImages.map((src, index) => (
              <div key={index} className="life-img-card">
                <img src={src} alt={`Life at Ridgeview ${index + 1}`} />
              </div>
            ))}
          </ScrollAnimation>
        </div>
      </section>

      {/*end gallery section */}



      {/* blog posts section */}
      <section className='blog-section mb-5'>
        <h2 className="life-heading" style={{ color: 'white', paddingBottom: '30px' }}>OUR BLOGS</h2>
        <div>

          {/* <p className='about-heading'>Our Blogs</p> */}
          {/* <hr className='slider-hr' /> */}
          <Swiper spaceBetween={30} slidesPerView={2} modules={[Autoplay, Navigation]} loop={true}
            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              992: {
                slidesPerView: 2,
              }
            }}>

            {blogs && blogs.length > 0 ? (

              blogs.map((blog, index) => (
                <SwiperSlide key={index}>
                  <div className='blog-container'>
                    <div className='blog-card'>
                      <div >
                        <img
                          src={`https://api.kcian.in/uploads/${blog.image}`}
                          alt='blogs'
                        />
                      </div>

                      <div className='blog-content'>
                        <h3>{blog.title}</h3>
                        <p>Posted On: {formatDate(blog.posted_on)}</p>
                        {/* <p>{blog.description}</p> */}
                        <p>
                          {blog.description.length > 100
                            ? blog.description.slice(0, 100) + "..."
                            : blog.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <p className='text-light'>
                No blog posts are available at the moment. Check back later for updates.
              </p>
            )}
          </Swiper>

        </div>
      </section>
      {/* blogs posts section ends */}
      {/* <br></br><br></br><br></br> */}

    </>
  )
}

export default Home

























// import React, { useState, useEffect } from 'react'
// import Banner1 from '../assets/banner1.png';
// import Banner2 from '../assets/banner-3.jpg';
// import ExImg from '../assets/exc-img.jpg';
// import 'animate.css';
// import ScrollAnimation from 'react-animate-on-scroll';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Navigation } from 'swiper/modules';
// import 'swiper/css';
// import Course1 from '../assets/course1.jpg';
// import Course2 from '../assets/course4.jpg';
// import { useNavigate } from 'react-router-dom';
// import AddDialog from '../general/AddDialog';


// const Home = ({ setResponse, setLoading }) => {
//   const navigate = useNavigate();
//   const [showAch, setShowAch] = useState(false);
//   const [notice, setNotice] = useState([]);
//   const [achieve, setAchieve] = useState([]);
//   const [blogs, setBlogs] = useState([]);
//   const [banner, setBanner] = useState([])


//   const fetchNotice = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch('https://api.kcian.in/get-notice');

//       if (response.ok) {
//         const data = await response.json();
//         data.sort((a, b) => new Date(b.date) - new Date(a.date));
//         setNotice(data);
//         setLoading(false);
//       } else {
//         setLoading(false);
//         console.error('Failed to fetch coupon');
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error('Error fetching data:', error);
//     }
//   };

//   const fetchAchievement = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch('https://api.kcian.in/get-achievement');

//       if (response.ok) {
//         const data = await response.json();
//         data.sort((a, b) => new Date(b.date) - new Date(a.date));
//         setAchieve(data);
//         setLoading(false);
//       } else {
//         setLoading(false);
//         console.error('Failed to fetch coupon');
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error('Error fetching data:', error);
//     }
//   };


//   const fetchBlogs = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch('https://api.kcian.in/get-blog');

//       if (response.ok) {
//         const data = await response.json();
//         data.sort((a, b) => new Date(b.posted_on) - new Date(a.posted_on));
//         setBlogs(data);
//         setLoading(false);
//       } else {
//         setLoading(false);
//         console.error('Failed to fetch coupon');
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error('Error fetching data:', error);
//     }
//   };


//   const fetchBanner = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch('https://api.kcian.in/get-banner');

//       if (response.ok) {
//         const data = await response.json();
//         setBanner(data);
//         setLoading(false);
//       } else {
//         setLoading(false);
//         console.error('Failed to fetch banner');
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error('Error fetching data:', error);
//     }
//   };

//   useEffect(() => {
//     fetchNotice();
//     fetchAchievement();
//     fetchBlogs();
//     fetchBanner();
//   }, []);

//   const formatDateTime = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleString('en-GB', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     }).replace(',', '');
//   };


//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric'
//     });
//   };



//   return (
//     <>
//       {/* slider section */}
//       <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
//   <div class="carousel-inner">
//         {banner.length > 0 ? (
//             banner.map((offer, index) => {
//                 const bannerUrl = `https://api.kcian.in/uploads/${offer.image}`;
//                 return (
//                   <>
//                     <div
//                         key={index}
//                         className={`carousel-item ${index === 0 ? 'active' : ''}`}
//                     >
//                             <img src={bannerUrl} class="slider-img w-100" alt="banner" />

//       <div className='carousel-content'>
//         <div className='carousel-inner2 animate__animated animate__fadeInUp'>
//         <hr className='slider-hr' />
//                             <p className='carousel-heading'>{offer.tagline}</p>
//                             <p>{offer.description}</p>
//                         </div>
//                         </div>
//                     </div>
//                     </>
//                 );
//             })
//         ) : (
//     <div className="slider-section" style={{ backgroundImage: `url(${Banner1})` }}>
//         <div className="slider-overlay">
//           <div className="slider-content">

//             <h1 className='fm-dscript'>
//               Enquire Today for <span className="highlight fm-dscript">Admissions</span>
//             </h1>
//             <p>Start your child’s educational journey with us! Enquire today to learn more about our admissions process, programs, and how we nurture academic excellence and holistic development.</p>
//             <button className="discover-now-btn"><a href='/'>Discover The School</a></button>
//           </div>
//         </div>
//       </div>
//         )}

//   </div>
//   <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
//     <span class="carousel-control-prev-icon" aria-hidden="true"></span>
//     <span class="visually-hidden">Previous</span>
//   </button>
//   <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
//     <span class="carousel-control-next-icon" aria-hidden="true"></span>
//     <span class="visually-hidden">Next</span>
//   </button>
// </div>

//       {/* slider section ends */}


//       {/* values section */}
//       <section className='px-4'>
//         <div className='value-outer container col-lg-8 col-12 text-center pb-3 mb-5'>

//           <div className='row'>

//             <div className='col-lg-4 col-md-4 col-12 px-0'>
//               <div className='bg-primary'>
//                 <p className='value-text cursor-pointer' onClick={() => navigate('/about')}>Our School</p>
//               </div>
//             </div>
//             <div className='col-lg-4 col-md-4 col-12 px-0'>
//               <div className='bg-primary'>
//                 <p className='value-text cursor-pointer' onClick={() => navigate('/academics')}>Notices</p>
//               </div>
//             </div>
//             <div className='col-lg-4 col-md-4 col-12 px-0'>
//               <div className='bg-primary'>
//                 <p className='value-text cursor-pointer' onClick={() => navigate('/achievements')}>Achievements</p>
//               </div>

//             </div>

//           </div>
//           {/* row ends */}
//           <p className='my-3 fw-semibold'>"Recognizing outstanding student performances and milestones that showcase our school’s dedication to excellence."</p>

//         </div>
//       </section>
//       {/* values section ends */}


//       {/* about section */}
//       <ScrollAnimation className='mb-5 container' animateIn='fadeInUp'>
//         <div className='py-5 px-md-5 px-4 bg-light rounded-4'>

//           <p className='about-heading'>What sets us part</p>

//           <p><span className='fs-1 fw-bold'>T</span>he school was established in the year 1984 by the sincere and dynamic efforts of Smt. V. Sugnana Kumari Deo, President, K. C. Trust Managing Committee. K. C. Trust is a non-profit, educational body widely recognized for its commitment to excellence in education. Education leadership and scholarly achievement is its mission. Strong in tradition it has evolved as a matrix among the educational institutions in the district of Ganjam, Odisha.</p>

//         </div>
//       </ScrollAnimation>
//       {/* about section ends */}


//       {/* excellence section */}
//       <section className='my-5'>
//         <div className='container'>

//           <div className='row'>

//             <ScrollAnimation className='col-lg-4 col-md-6 col-12 my-2' animateIn='fadeInLeft'>
//               <p className='about-heading'>Mission & Excellence</p>
//               <p className='text-muted'>Evoking a passion for learning and developing the requisite set of knowledge and skill that enable our learners to become positive and responsible participant in the rapidly progressing community.</p>
//               <p className='text-muted'><i class="fa-solid fa-circle text-danger"></i> International reputation</p>
//               <p className='text-muted'><i class="fa-solid fa-circle text-warning"></i> Prepares future leaders</p>
//               <p className='text-muted'><i class="fa-solid fa-circle text-success"></i> Moral and spiritual compass</p>
//               <p className='text-muted'><i class="fa-solid fa-circle"></i> Curriculum and instruction</p>
//             </ScrollAnimation>

//             <div className='col-lg-4 col-md-6 col-12 my-2'>
//               <img src={ExImg} className='img-fluid' alt='excellence' />
//             </div>

//             <ScrollAnimation className='col-lg-4 col-md-6 col-12 my-2' animateIn='fadeInRight'>
//               <p className='d-flex'><i class="fa-solid fa-graduation-cap bg-primary rounded-circle py-2 px-2 me-2 text-light"></i> Excellence in Education</p>
//               <hr />

//               <p className='d-flex'><i class="fa-solid fa-graduation-cap bg-primary rounded-circle py-2 px-2 me-2 text-light"></i> Critical Thinking & Inquiry</p>
//               <hr />

//               <p className='d-flex'><i class="fa-solid fa-graduation-cap bg-primary rounded-circle py-2 px-2 me-2 text-light"></i> Integrity and Ethics</p>
//               <hr />

//               <p className='d-flex'><i class="fa-solid fa-graduation-cap bg-primary rounded-circle py-2 px-2 me-2 text-light"></i> Inclusive Learning</p>
//               <hr />

//               <p className='d-flex'><i class="fa-solid fa-graduation-cap bg-primary rounded-circle py-2 px-2 me-2 text-light"></i> Collaborative Growth</p>
//               <hr />
//             </ScrollAnimation>

//           </div>
//           {/* row ends */}

//         </div>
//       </section>
//       {/* excellence section */}


//       {/* notice section */}
//       <section className='pb-5 px-3'>
//         <div className='container bg-light py-5 px-4 rounded-4'>

//           <div className='d-flex justify-content-between'>
//             <p className='about-heading'>Latest Notice</p>
//             <p className='align-content-center fw-bold fm-mont cursor-pointer' onClick={() => navigate('/academics')}>View All <i class="fa-solid fa-clipboard-list"></i></p>
//           </div>

//           <div className='notice-area'>


//             {notice && notice.length > 0 ? (
//               notice.slice(0, 3).map((notices, index) => (
//                 <div key={index} className='my-3 border-bottom'>
//                   <p className='fw-bold fm-mont my-1'>{notices.tagline}</p>
//                   <p className='para-text text-muted fw-semibold'>Date Posted On: {formatDateTime(notices.date)}</p>
//                   <p className='text-muted fm-mont para-text'>Details: {notices.description}</p>
//                 </div>
//               ))
//             ) : (
//               <p className='my-3 text-muted'>There are currently no notices to display. Please check back later for updates.</p>
//             )}

//           </div>

//         </div>
//       </section>
//       {/* notice section ends */}



//       {/* achievements section */}
//       <section className='py-5 course-sec'>
//         <div className='container text-center'>

//           <p className='about-heading'>Our Achievements</p>

//           <Swiper spaceBetween={30} slidesPerView={3} modules={[Autoplay, Navigation]} loop={true} className='mt-4 py-2'
//             navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
//             breakpoints={{
//               0: {
//                 slidesPerView: 1,
//               },
//               768: {
//                 slidesPerView: 2,
//               },
//               992: {
//                 slidesPerView: 3,
//               }
//             }}>


//             {achieve && achieve.length > 0 ? (
//               achieve.map((ach, index) => (
//                 <SwiperSlide key={index}>
//                   <div className='achievement-area'>
//                     <img
//                       src={`https://api.kcian.in/uploads/${ach.image}`}
//                       className='img-fluid w-100'
//                       alt='achievements'
//                     />
//                     <div className='px-2 py-3'>
//                       <p className='fw-bold mb-0'>{ach.tagline}</p>
//                       <p className='text-muted para-text'>
//                         Posted On: {formatDateTime(ach.posted_on)} by {ach.added_by}
//                         <br />
//                         {ach.batch ? <>Batch: {ach.batch}</> : null}
//                       </p>
//                       <p className='text-muted'>{ach.description}</p>
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               ))
//             ) : (
//               <p className='text-muted my-3'>
//                 There are currently no achievements to display. Check later for updates.
//               </p>
//             )}


//           </Swiper>

//         </div>
//       </section>
//       {/* achievements section ends */}


//       {/* quote section */}
//       <section className='bg-light py-5'>
//         <div className='container d-md-flex justify-content-between'>

//           <p className='fw-semibold col-lg-8'>"Celebrate academic and co-curricular milestones by adding your achievements. Share your success stories and inspire others as part of our growing community of proud and accomplished learners."
//           </p>

//           <button className='carousel-btn text-nowrap' onClick={() => setShowAch(true)}>Add Achievements</button>


//         </div>
//       </section>
//       {/* quote section ends */}


//       {/* blog posts section */}
//       <section className='my-5'>
//         <div className='container'>

//           <p className='about-heading'>Our Blogs</p>
//           <hr className='slider-hr' />

//           <Swiper spaceBetween={30} slidesPerView={2} modules={[Autoplay, Navigation]} loop={true} className='mt-4'
//             navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
//             breakpoints={{
//               0: {
//                 slidesPerView: 1,
//               },
//               768: {
//                 slidesPerView: 1,
//               },
//               992: {
//                 slidesPerView: 2,
//               }
//             }}>

//             {blogs && blogs.length > 0 ? (
//               blogs.map((blog, index) => (
//                 <SwiperSlide key={index}>
//                   <div className='row'>
//                     <div className='col-lg-4 col-md-4 col-12 my-2'>
//                       <img
//                         src={`https://api.kcian.in/uploads/${blog.image}`}
//                         className='img-fluid w-100'
//                         alt='blogs'
//                       />
//                     </div>

//                     <div className='col-lg-8 col-md-8 col-12 my-2 align-content-center'>
//                       <p className='fw-bold my-0'>{blog.title}</p>
//                       <p className='text-muted para-text'>Posted On: {formatDate(blog.posted_on)}</p>
//                       <p className='text-muted'>{blog.description}</p>
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               ))
//             ) : (
//               <p className='text-muted'>
//                 No blog posts are available at the moment. Check back later for updates.
//               </p>
//             )}


//           </Swiper>

//         </div>
//       </section>
//       {/* blogs posts section ends */}


//       {showAch && <AddDialog setShowAch={setShowAch} setResponse={setResponse} setLoading={setLoading} />}

//     </>
//   )
// }

// export default Home
